import React, {useState, useEffect} from "react";
import { useNavigate, useParams } from "react-router-dom";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import { useAuthState } from "react-firebase-hooks/auth";
import { getAuth } from "firebase/auth";
import { auth } from "services/firebaseConfig";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "services/firebaseConfig";
import ModalDelete from "components/features/ModalDelete";
import Funcionario from "components/features/funcionario";
import TemCurriculo from "components/features/temCurriculo";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import HeaderFuncionario from "components/headers/lightFuncionaario";
import Footer from "components/footers/Footer.js";
import ContactUsForm from "components/forms/TwoColContactUsWithIllustrationFullForm.js";
import ContactDetails from "components/cards/ThreeColContactDetails.js";
import SimpleContactUs from "components/forms/SimpleContactUs";

const Address = tw.span`leading-relaxed`;

const AddressLine = tw.span`block`;
const Email = tw.span`text-sm mt-6 block text-gray-500`;
const Phone = tw.span`text-sm mt-0 block text-gray-500`;


export default (props) => {
  const [nome, setNome] = useState("")
  const [usuarios, setUsuarios] = useState([]);
  const [newUser, setNewUser] = useState(false)
    const navigate = useNavigate();
    const [user, loading, error] = useAuthState(auth);
    const [temCurriculo, setTemCurriculo] = useState("");
    const [tipo, setTipo] = useState("");
    const [userUid, setUserUid] = useState("");
    
    if (error) {
      return (
        <div>
          <p>Error: {error}</p>
        </div>
      );
    }
    if (!user) {
      navigate("../")     
    }
      const usersCollectionRef = collection(db, "users");
      
    useEffect(() => {
  if (user) {
    const q = query(usersCollectionRef, where("uid", "==", String(user.uid)));
        const getUsers = async () => {
            const data = await getDocs(q)
            console.log(data);
            setUsuarios(data.docs.map((doc)=> ({...doc.data(), id: doc.id})))
            
        }
        getUsers()
      }
    }, [user] )
   
    useEffect(() => {
      if (user) {
        const q = query(usersCollectionRef, where("uid", "==", String(user.uid)));
            const getUsers = async () => {
                const data = await getDocs(q)
                console.log(data);
                setUsuarios(data.docs.map((doc)=> ({...doc.data(), id: doc.id})))
                
            }
            getUsers()
          }
        }, [newUser] )
    
    useEffect(()=> {
      if(usuarios[0]){
        setNome(usuarios[0].nome)
        if(usuarios[0].curriculo){
          setTemCurriculo(true)
        } else {
          setTemCurriculo(false)
        }
          setUserUid(usuarios[0].uid)
          setTipo(usuarios[0].tipo)       
      }
      console.log(temCurriculo + "  " + tipo)
        
    }, [usuarios])
    

  return (
    <>
    <AnimationRevealPage>
      {tipo != "funcionario"  &&<Header navigate={navigate} />}
      {tipo == "funcionario"  &&<HeaderFuncionario navigate={navigate} />}
      {!temCurriculo && tipo == "usuario"  && <SimpleContactUs nome={nome} setNewUser={setNewUser} setTemCurriculo={setTemCurriculo} user={user} />}
      {temCurriculo && tipo == "usuario"  && <TemCurriculo user={usuarios[0]} setCurriculoAtual={props.setCurriculoAtual} />}
      {tipo == "funcionario"  && <Funcionario user={user} setCurriculoAtual={props.setCurriculoAtual} />}
      
      
      <Footer />
    </AnimationRevealPage></>
  );
};
